var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c(
      "div",
      { staticClass: "concent" },
      [
        _vm.carouselList && _vm.carouselList.length > 0
          ? _c("div", { staticClass: "c_lbt" }, [
              _c(
                "div",
                { staticClass: "carousel" },
                [
                  _c(
                    "swiper",
                    {
                      ref: "mySwiper",
                      staticClass: "mySwiper swiper-no-swiping",
                      attrs: { options: _vm.swiperOptions },
                    },
                    _vm._l(_vm.carouselList, function (item, index) {
                      return _c("swiper-slide", { key: index }, [
                        _c("div", { staticClass: "swiper_side" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  item.type == 3
                                    ? item.external_link
                                    : "/play-page?id=" +
                                      item.id +
                                      "&classify=" +
                                      item.classify,
                                target: "_blank",
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "index1",
                                attrs: { src: item.img_url[0], height: "464" },
                              }),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    1
                  ),
                  _c("div", { staticClass: "carousel-right" }, [
                    _c(
                      "ul",
                      { staticClass: "cr-ul" },
                      _vm._l(_vm.carouselList, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "cu-li",
                            class: {
                              selectLi: _vm.slideIndex == index,
                              preselectLi: _vm.slideIndex - 1 == index,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.slideClick(index)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "cul_title1" }, [
                              _c("p", [_vm._v(_vm._s(item.article_title))]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.channelList && _vm.channelList.length > 0
          ? _c(
              "div",
              { staticClass: "c_channel" },
              _vm._l(_vm.channelList, function (item) {
                return _c(
                  "div",
                  { key: item.at_id, staticClass: "channel_item" },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            item.at_name == "推荐"
                              ? "/marvel-list?id=" + item.at_id
                              : "/list-page?id=" + item.at_id,
                          target: "_blank",
                        },
                      },
                      [_vm._v(" " + _vm._s(item.at_name) + " ")]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm.newList.length > 0
          ? _c("div", { staticClass: "c_recommend" }, [
              _c("div", { staticClass: "pub_title" }, [
                _c("img", {
                  attrs: { src: require("@/assets/home/tuijian.png"), alt: "" },
                }),
                _c("h4", [_vm._v("最新推荐")]),
              ]),
              _c(
                "div",
                { staticClass: "recommend_item" },
                [
                  _c(
                    "swiper",
                    {
                      staticClass: "new_swiper",
                      attrs: { options: _vm.newSwiperOptions },
                    },
                    _vm._l(_vm.newList, function (item) {
                      return _c("swiper-slide", { key: item.id }, [
                        _c("div", { staticClass: "item_list" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/play-page?id=" +
                                  item.id +
                                  "&classify=" +
                                  item.classify,
                                target: "_blank",
                              },
                            },
                            [
                              _c("div", { staticClass: "ril_img" }, [
                                _c("img", {
                                  attrs: { src: item.img_url[0], alt: "" },
                                }),
                                _c("div", { staticClass: "time" }, [
                                  _vm._v(_vm._s(item.video_duration)),
                                ]),
                              ]),
                              _c("div", { staticClass: "ril_concent" }, [
                                _c("div", { staticClass: "rilc_t1" }, [
                                  _vm._v(_vm._s(item.title)),
                                ]),
                                _c("div", {
                                  staticClass: "rilc_t2",
                                  domProps: { innerHTML: _vm._s(item.desc) },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    1
                  ),
                  _vm.hasMore
                    ? _c("div", {
                        staticClass:
                          "swiper-button-next new-button-next el-icon-arrow-right",
                        attrs: { slot: "pagination" },
                        slot: "pagination",
                      })
                    : _vm._e(),
                  _vm.hasMore
                    ? _c("div", {
                        staticClass:
                          "swiper-button-prev new-button-prev el-icon-arrow-left",
                        attrs: { slot: "pagination" },
                        slot: "pagination",
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.hotList.length > 0
          ? _c("div", { staticClass: "c_billboard" }, [
              _c("div", { staticClass: "pub_title" }, [
                _c("img", {
                  attrs: { src: require("@/assets/home/reban.png"), alt: "" },
                }),
                _c("h4", [_vm._v("最热榜单")]),
              ]),
              _c("div", { staticClass: "cb_concent" }, [
                _c(
                  "div",
                  { staticClass: "cbc_order" },
                  _vm._l(_vm.hotList, function (item, index) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "order_item" },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "/play-page?id=" +
                                item.id +
                                "&classify=" +
                                item.classify,
                              target: "_blank",
                            },
                          },
                          [
                            _c("div", { staticClass: "orde_sum" }, [
                              _vm._v("0" + _vm._s(index + 1) + "."),
                            ]),
                            _c("div", { staticClass: "orde_title" }, [
                              _c("div", { staticClass: "ot1" }, [
                                _vm._v(_vm._s(item.title)),
                              ]),
                              _c("div", {
                                staticClass: "ot2",
                                domProps: { innerHTML: _vm._s(item.desc) },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "cbc_list" },
                  _vm._l(_vm.hotList, function (item) {
                    return _c("div", { key: item.id, staticClass: "cl_item" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "/play-page?id=" +
                              item.id +
                              "&classify=" +
                              item.classify,
                            target: "_blank",
                          },
                        },
                        [
                          _c("div", { staticClass: "cli_img" }, [
                            _c("img", {
                              attrs: { src: item.img_url[0], alt: "" },
                            }),
                          ]),
                          _c("div", { staticClass: "cli_title" }, [
                            _c("div", { staticClass: "cli_t1" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                            _c("div", {
                              staticClass: "cli_t2",
                              domProps: { innerHTML: _vm._s(item.desc) },
                            }),
                          ]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _vm._e(),
        _vm.followFirst || _vm.followSubList.length > 0
          ? _c("div", { staticClass: "c_like" }, [
              _c("div", { staticClass: "pub_title" }, [
                _c("img", {
                  attrs: { src: require("@/assets/home/like.png"), alt: "" },
                }),
                _c("h4", [_vm._v("你可能喜欢")]),
              ]),
              _vm.followFirst
                ? _c("div", { staticClass: "ck_big" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/play-page?id=" +
                            _vm.followFirst.id +
                            "&classify=" +
                            _vm.followFirst.classify,
                          target: "_blank",
                        },
                      },
                      [
                        _c("div", { staticClass: "ckb_img" }, [
                          _c("img", {
                            attrs: { src: _vm.followFirstImg, alt: "" },
                          }),
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(_vm.followFirst.video_duration)),
                          ]),
                        ]),
                        _c("div", { staticClass: "ckb_title" }, [
                          _c("div", { staticClass: "ckt1" }, [
                            _vm._v(_vm._s(_vm.followFirst.title)),
                          ]),
                          _c("div", {
                            staticClass: "ckt2",
                            domProps: {
                              innerHTML: _vm._s(_vm.followFirst.desc),
                            },
                          }),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "ck_small" },
                _vm._l(_vm.followSubList, function (item) {
                  return _c("div", { key: item.id, staticClass: "ckm_item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/play-page?id=" +
                            item.id +
                            "&classify=" +
                            item.classify,
                          target: "_blank",
                        },
                      },
                      [
                        _c("div", { staticClass: "cmi_img" }, [
                          _c("img", {
                            attrs: { src: item.img_url[0], alt: "" },
                          }),
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(item.video_duration)),
                          ]),
                        ]),
                        _c("div", { staticClass: "cki_title" }, [
                          _c("div", { staticClass: "ckit1" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _c("div", {
                            staticClass: "ckit2",
                            domProps: { innerHTML: _vm._s(item.desc) },
                          }),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm.marvellousList.length > 0
          ? _c("div", { staticClass: "c_video" }, [
              _c(
                "div",
                { staticClass: "pub_title" },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/home/video.png"), alt: "" },
                  }),
                  _c("h4", [_vm._v("精彩视频")]),
                  _c(
                    "el-button",
                    { staticClass: "cv_btn", attrs: { type: "text" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              path: "/marvel-list",
                            },
                            target: "_blank",
                          },
                        },
                        [_vm._v("更多 ")]
                      ),
                      _c("i", {
                        staticClass: "el-icon-arrow-right el-icon--right",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "cv_list" },
                [
                  _c(
                    "swiper",
                    {
                      staticClass: "marvel_swiper",
                      attrs: { options: _vm.swiperOptionsVideo },
                    },
                    _vm._l(_vm.marvellousList, function (item) {
                      return _c("swiper-slide", { key: item.id }, [
                        _c("div", { staticClass: "cvl_item" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/play-page?id=" +
                                  item.id +
                                  "&classify=" +
                                  item.classify,
                                target: "_blank",
                              },
                            },
                            [
                              _c("div", { staticClass: "cvl_img" }, [
                                _c("img", {
                                  attrs: { src: item.img_url[0], alt: "" },
                                }),
                                _c("div", { staticClass: "time" }, [
                                  _vm._v(_vm._s(item.video_duration)),
                                ]),
                              ]),
                              _c("div", { staticClass: "cvl_title" }, [
                                _vm._v(_vm._s(item.title)),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    1
                  ),
                  _c("div", {
                    staticClass:
                      "swiper-button-next marvel-button-next el-icon-arrow-right",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                  _c("div", {
                    staticClass:
                      "swiper-button-prev marvel-button-prev el-icon-arrow-left",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm.videoChannel.length > 0
          ? _c(
              "div",
              { staticClass: "c_video_channel" },
              _vm._l(_vm.videoChannel, function (item) {
                return _c(
                  "div",
                  {
                    key: item.title,
                    staticClass: "cvc_item",
                    on: {
                      click: function ($event) {
                        _vm.isCollapse = item.id
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        class: _vm.isCollapse == item.id ? "active" : "",
                        attrs: {
                          to: {
                            path: "",
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.title) + " ")]
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm.isCollapse % 4 == 3
          ? _c("video-normal", { attrs: { id: _vm.isCollapse } })
          : _vm._e(),
        _vm.isCollapse % 4 == 0 ? _c("video-boutique") : _vm._e(),
        _vm.isCollapse % 4 == 1
          ? _c("video-album", { attrs: { id: _vm.isCollapse } })
          : _vm._e(),
        _vm.isCollapse % 4 == 2 ? _c("video-master") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }